import React, { useContext, useState, useEffect } from "react"
import { makeStyles } from "@material-ui/styles"
import { Slide, Typography } from "@material-ui/core"
import { CartContext } from ".."
import Checkmark from "./check.svg"

const useStyles = makeStyles(theme => {
  return {
    root: {
      alignItems: "center",
      background: theme.palette.green.support,
      display: "flex",
      height: theme.spacing(6),
      justifyContent: "center",
      position: "absolute",
      top: "100%",
      width: "100%",
      zIndex: -1,
    },
    check: {
      marginRight: theme.spacing(1.5),
    },
  }
})

const useCartListener = () => {
  const [visible, setVisible] = useState(false)
  const [productName, setProductName] = useState("")
  const { on } = useContext(CartContext) || {}
  useEffect(() => {
    on("addedToCart", ({ name }) => {
      setVisible(true)
      setProductName(name)
      setTimeout(() => {
        setVisible(false)
      }, 3000)
    })
  }, [])
  return [productName, visible]
}

export default props => {
  const classes = useStyles(props)
  const [productName, visible] = useCartListener()
  return (
    <Slide direction="down" in={visible}>
      <div className={classes.root}>
        <img className={classes.check} src={Checkmark} alt={""} />
        <Typography component={"div"}>
          {`${productName} ${props.copyText}`}
        </Typography>
      </div>
    </Slide>
  )
}
